import React from "react";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";

export default function CountStatics({data}) {
  return (
    <Grid container spacing={3}>
      {data.map((item, index) =>{
        return <Grid key={item.id} item xs={4} className="px-2">
          <Card className={`staticCard box-${index} h-100`}>
            <CardContent>
              <Grid container>
                <Grid item xs={12} className="infoSection">
                  <span><Translator id={item.title}/></span>
                  <Typography variant="body2" component="p" className="mt-2">
                    {item.value}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      })}
    </Grid>
  );
};